const firebaseErrorMessages = {
  'auth/invalid-email': 'The email address is not valid.',
  'auth/user-disabled': 'This user account has been disabled.',
  'auth/user-not-found': 'No account found with this email.',
  'auth/wrong-password': 'Incorrect password. Please try again.',
  'auth/invalid-credential': 'Invalid login credentials.',
  'auth/invalid-login-credentials': 'Incorrect email or password.',
  'auth/email-already-in-use': 'This email is already registered.',
  'auth/weak-password': 'Password is too weak (minimum 6 characters).',
  'auth/too-many-requests': 'Too many attempts. Please try again later.',
  'auth/network-request-failed': 'Network error. Check your connection.',
  'auth/missing-email': 'Please enter an email address.',
  'auth/popup-closed-by-user': 'Login popup was closed.',
  'auth/popup-blocked': 'Popup blocked by browser.',
};

export function getFriendlyError(error) {
  return firebaseErrorMessages[error.code] || 'Something went wrong. Please try again.';
}
